export const CAMPOS_GOFLOW = [
  { clave: 'survey_Score_OverallTI', obligatorio: true, visible: true, dataset: 1, validacion: 'Decimal' },
  { clave: 'survey_Score_Camaraderie', obligatorio: true, visible: true, dataset: 1, validacion: 'Decimal' },
  { clave: 'survey_Score_Credibility', obligatorio: true, visible: true, dataset: 1, validacion: 'Decimal' },
  { clave: 'survey_Score_Imparciality', obligatorio: true, visible: true, dataset: 1, validacion: 'Decimal' },
  { clave: 'survey_Score_Pride', obligatorio: true, visible: true, dataset: 1, validacion: 'Decimal' },
  { clave: 'survey_Score_Respect', obligatorio: true, visible: true, dataset: 1, validacion: 'Decimal' },
  { clave: 'survey_Score_Gestalt', obligatorio: true, visible: true, dataset: 1, validacion: 'Decimal' },
  { clave: 'numUsers', obligatorio: true, visible: true, dataset: 1, validacion: 'numerica' },
  { clave: 'pdf_DateCreation', obligatorio: true, visible: true, dataset: 1, validacion: 'date' },

];
